export const navbarGroups = {
  assortment: 'assortment',
  promo: 'promo',
  actions: 'actions',
  favouriteOrderList: 'favouriteOrderList',
  priceUpdates: 'priceUpdates',
  users: 'users',
  home: 'home',
  partner: 'partner',
}
